import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { compose } from 'recompose'

import { Header } from 'components/layout'
import { setActiveOrganization } from 'redux/modules/auth'
import { modal } from 'redux/modules/app'
import { getPhotoUrl } from 'utils/token'
import styles from './blank-main.styl'
import { renderRoutes } from 'react-router-config'
import config from 'config'

const enhance = compose(
  connect(
    ({ auth, app, api }) => ({
      user: auth.user,
      organization: auth.organization,
      configuration: api.configuration,
      page: app.page
    }),
    { setActiveOrganization, modal, push }
  )
)

class BlankMain extends Component {
  static propTypes = {
    user: PropTypes.object,
    organization: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired,
    route: PropTypes.object,
    children: PropTypes.object.isRequired,
    setActiveOrganization: PropTypes.func.isRequired,
    modal: PropTypes.func,
    push: PropTypes.func
  }
  static defaultProps = {}

  componentWillReceiveProps(nextProps) {
    const { user } = this.props

    if (get(user, 'access_token') && !get(nextProps, 'user.access_token')) {
      this.props.push(`${config.publicPath}/logout`)
    }
  }

  render() {
    const {
      children,
      user,
      page,
      route,
      organization,
      location
    } = this.props

    if (!get(user, 'access_token')) {
      return children
        ? React.cloneElement(children)
        : renderRoutes(route.routes)
    }

    return (
      <div className={styles.layout}>
        <Header
          user={user}
          page={page}
          routes={route.routes}
          location={location}
          photoUrl={getPhotoUrl(user)}
          organization={organization}
          setActiveOrganization={this.props.setActiveOrganization}
          modal={this.props.modal}
          push={this.props.push}
          isBlank
        />
        <div className={styles.wrapper}>
          <div className={styles.main}>
            <div className="container">
              {children
                ? React.cloneElement(children)
                : renderRoutes(route.routes)
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default enhance(BlankMain)
